module.exports = __webpack_public_path__ + "img/list04.afceab66.png";